var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTableIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 20 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 3H6c-.6 0-1-.4-1-1s.4-1 1-1h13c.6 0 1 .4 1 1s-.4 1-1 1zM19 9H6c-.6 0-1-.4-1-1s.4-1 1-1h13c.6 0 1 .4 1 1s-.4 1-1 1zM19 15H6c-.6 0-1-.4-1-1s.4-1 1-1h13c.6 0 1 .4 1 1s-.4 1-1 1zM1 3H.8c-.1 0-.1 0-.2-.1-.1 0-.1-.1-.2-.1s-.1-.1-.1-.1c-.1-.1-.2-.2-.2-.3C0 2.3 0 2.1 0 2c0-.1 0-.3.1-.4.1-.1.1-.2.2-.3.3-.3.7-.4 1.1-.2.1.1.2.1.3.2.2.2.3.4.3.7 0 .3-.1.5-.3.7-.2.2-.4.3-.7.3zM1 9c-.3 0-.5-.1-.7-.3C.1 8.5 0 8.3 0 8v-.2c0-.1 0-.1.1-.2 0-.1.1-.1.1-.2s.1-.1.1-.1c.1-.1.2-.2.3-.2.4-.2.8-.1 1.1.2l.1.1c0 .1.1.1.1.2s0 .1.1.2V8c0 .3-.1.5-.3.7-.2.2-.4.3-.7.3zM1 15c-.3 0-.5-.1-.7-.3-.2-.2-.3-.4-.3-.7 0-.1 0-.3.1-.4.1-.1.1-.2.2-.3.4-.4 1-.4 1.4 0 .2.2.3.4.3.7 0 .3-.1.5-.3.7-.2.2-.4.3-.7.3z",
    fill: "#ED1B2E"
  })));
}

export default SvgTableIcon;